// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function empty(param) {
  return {
          id: undefined,
          value: undefined,
          length: undefined,
          countryCode: undefined
        };
}

function id(t) {
  return t.id;
}

function value(t) {
  return t.value;
}

function length(t) {
  return t.length;
}

function countryCode(t) {
  return t.countryCode;
}

function setLength(t, length) {
  return {
          id: t.id,
          value: t.value,
          length: length,
          countryCode: t.countryCode
        };
}

function setCountryCode(t, countryCode) {
  return {
          id: t.id,
          value: t.value,
          length: t.length,
          countryCode: countryCode
        };
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          value: Json_decode.optional((function (param) {
                  return Json_decode.field("value", Json_decode.string, param);
                }), json),
          length: Json_decode.optional((function (param) {
                  return Json_decode.field("length", Json_decode.$$int, param);
                }), json),
          countryCode: Json_decode.optional((function (param) {
                  return Json_decode.field("country_code", Json_decode.string, param);
                }), json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "length",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), t.length)
                ],
                tl: {
                  hd: [
                    "country_code",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), t.countryCode)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

var dataTypeName = "MsisdnType";

exports.empty = empty;
exports.dataTypeName = dataTypeName;
exports.id = id;
exports.value = value;
exports.length = length;
exports.countryCode = countryCode;
exports.setLength = setLength;
exports.setCountryCode = setCountryCode;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
